import React, {Component} from "react";
import {configHeaderVariant} from "./config";
import {configYearToDateInden, yearOptions} from "../config";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { HttpStatus } from "../../../../common/Constants";
import * as R from "ramda";
class IndentReportYearToDate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            year: null,
            tableConfig: [
                {name: "variantCode", label: "Kode Varian", options: {sort: false}},
                {name: "variantName", label: "Nama Varian", options: {sort: false}},
                ...configYearToDateInden()
            ],
            dataTable: [],
        };
    };

    componentDidMount = () => {
        let currentDate = new Date();
        this.setState((prevValue) => ({
            ...prevValue,
            year: yearOptions.find(item => item.value === currentDate.getFullYear()),
        }), () => this.fetchDataLaporanIndentMothlyYtd());
    };

    componentDidUpdate(prevProps, prevState) { 
        if(prevProps.doSearch !== this.props.doSearch && this.props.doSearch){
            this.fetchDataLaporanIndentMothlyYtd();
        }
    } 

    fetchDataLaporanIndentMothlyYtd = async () => {
      this.props.handleTriggerLoading();

      let dataKodeCabang = this.props.search;
      if (this.props.isAllSelected) {
        dataKodeCabang = this.props.dataCabang.map((item) => item.kodeCabang);
      }

      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanIndentMothly,
        setError: this.props.setError,
        menuName:
          "Dashboard Level Kepala Cabang Keatas - Laporan Inden Perbulan Year To Date",
        args: {
          kodeCabang: dataKodeCabang,
          year: this.state.year?.value,
          employeeIdTeamLeader: this.props.idLeader,
        },
      });

      this.props.handleTriggerLoading();
      this.props.onSuccessSearch();

      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        const transformed = res.data.data.map((item) => {
          const { dataMonthlyVariant = {}, ...rest } = item;
          return {
            ...rest,
            ...dataMonthlyVariant,
          };
        });

        this.setState((prevValue) => ({
          ...prevValue,
          dataTable: transformed,
        }));
      }
    };

    handleSearch(){
        this.setState(prev=>({
            ...prev,
            tableConfig: [
                {name: "variantCode", label: "Kode Varian", options: {sort: false}},
                {name: "variantName", label: "Nama Varian", options: {sort: false}},
                ...configYearToDateInden(prev.year?.value)
            ],
        }), () => this.fetchDataLaporanIndentMothlyYtd())
    }

    handleChangeSearchValue(name, value) {
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: value,
        }));
    }

    render() {
        return (
            <>
                <FlexView style={{gap: "20px", alignItems: "center"}}>
                    <SimpleDDL
                        id="select_options_year"
                        box="search"
                        name="year"
                        containerclassname="width width-250px"
                        placeholder="Tahun"
                        menuPosition="fixed"
                        isClearable
                        options={yearOptions}
                        value={this.state.year}
                        onChange={(value, {name}) => this.handleChangeSearchValue(name, value)}
                    />
                    <SimpleButton
                        styles={{marginBottom: "20px"}}
                        onClick={()=>this.handleSearch()}
                    >Cari</SimpleButton>
                </FlexView>
                <SimpleDataTable
                    data={this.state.dataTable}
                    columns={this.state.tableConfig}
                    options={{pagination: false, serverSide: false}}
                />
            </>
        );
    };
}

export default IndentReportYearToDate;